import { graphql } from "react-relay";

export const VIDEO_SOURCE_VIDEO_SOURCE_FRAGMENT = graphql`
	fragment videoSourcesTableActionColumn_Vimeo_VimeoVideoSourceFragment on Vimeo_VimeoVideoSource {
		...deleteVideoSourceButton_Vimeo_VimeoVideoSourceFragment
		...setVideoSourceAsDefaultButton_Vimeo_VimeoVideoSourceFragment
		...editVideoSourceButton_Vimeo_VimeoVideoSourceFragment
	}
`;
